module.exports = __webpack_public_path__ + "img/trip_02.f25134c7.jpg";